import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, Observable, throwError } from "rxjs";
import { environment } from "src/environments/environment";
import { Asset } from "../models/asset.model";

let httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
    }),
  };

@Injectable({
    providedIn: "root",
  })

export class AssetService {
    private assetsUrl = environment.api + "Assets/";
    private serial : boolean = false;
    private imei: boolean = false;
    constructor(private http: HttpClient) {

    }

    //get

    public getAssetBySerialNumber(serialNumber: string): Observable<Asset> {
        return this.http
          .get<Asset>(this.assetsUrl + "search/" + serialNumber, httpOptions)
          .pipe(catchError(this.handleError));
      }

      private handleError(error: HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
          console.error("Fout:", error.error.message);
        } else {
          console.error(
            `Backend returned code Deze code voor handling ${error.status}` +
              ` body was: ${error.error}`
          );
        }
    
        return throwError("Something went wrong");
      }

      public setSerial(value: boolean){
        this.serial = value;
      }
      public getSerial():boolean{
        return this.serial
      }
      public setImei(value: boolean){
        this.imei = value;
      }
      public getImei():boolean{
        return this.imei;
      }

}